export default __webpack_public_path__ + "static/media/curtleryIcon.6b1bb253.svg";